import React from 'react';
import { Image, Modal, Pressable, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Icon } from '@ant-design/react-native';
import { VideoViewer } from '@shared/components/VideoViewer';
import { colorPalette } from '@shared/config/colorsConfig';
import { useI18n } from '@shared/i18n/useI18n';
import type { TChatMediaModalProps } from '../../types';

export const ChatMediaModal = ({ media, onClose }: TChatMediaModalProps) => {
    const { t } = useI18n();
    const insets = useSafeAreaInsets();

    return (
        <Modal visible={media !== null} transparent={false} animationType="fade" onRequestClose={onClose}>
            <View className="flex-1 bg-black">
                {media &&
                    (media.isImage ? (
                        <Image className="flex-1 w-full h-full" source={{ uri: media.uri }} resizeMode="contain" />
                    ) : (
                        <VideoViewer videoUrl={media.uri} />
                    ))}
                <Pressable
                    onPress={onClose}
                    accessibilityRole="button"
                    accessibilityLabel={t('screens.chat.closeMedia')}
                    hitSlop={12}
                    style={{ top: insets.top + 8 }}
                    className="absolute right-4 w-10 h-10 rounded-full bg-black/60 items-center justify-center"
                >
                    <Icon name="close" size={20} color={colorPalette.white} />
                </Pressable>
            </View>
        </Modal>
    );
};
